const findElementNomBene = (array, searchElement) => {
  if (array?.length !== undefined) {
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < array.length; i++) {
      const element = array[i];
      if (element.nombreBeneficiado === undefined) return null;
      if (element.nombreBeneficiado === searchElement) {
        return i;
      }
    }
  }
  return -1;
};

const eliminarObjetosDuplicadosPorPropiedad = (
  arr,
  propiedad1,
  propiedad2,
  propiedad3,
  propiedad4
) => {
  const objetoTemporal = {};
  return arr.filter((objeto) => {
    const clave = objeto[propiedad1] + objeto[propiedad2] + objeto[propiedad3] + objeto[propiedad4];
    if (!objetoTemporal[clave]) {
      objetoTemporal[clave] = true;
      return true;
    }
    return false;
  });
};

export const getBase64Image = (archivo) => {
  if (!archivo) return undefined;
  if (archivo.fileList[0]?.url) return null;
  return archivo.fileList[0]?.originFileObj.fullBase64Img?.split(',')[1];
};

export const newFormatBeneficiados = (
  beneficiados,
  catalogoBeneficiados,
  idProcesoEspecifico,
  beneficiadosOriginales
) => {
  let beneficiadoTemp;
  const beneficiadosFormateados = beneficiados?.map((beneficiado, index) => {
    if (beneficiado.beneficiado > 0) {
      beneficiadoTemp =
        catalogoBeneficiados?.find((b) => b.idContabilidad === beneficiado.beneficiado) || {};
      const beneficiadoFormateado = {
        ...beneficiadoTemp,
        pkBeneficiado: index + 1
      };
      return beneficiadoFormateado;
    }

    if (beneficiado.beneficiado === undefined && beneficiado.idSujetoObligado !== 0) {
      // const beneficiadosTemporales =
      //   catalogoBeneficiados?.filter(
      //     (b) =>
      //       b.idProcesoSIMAC === idProcesoEspecifico &&
      //       b.idSujetoObligado === beneficiado.idSujetoObligado &&
      //       b.idTipoAsociacion === beneficiado.idTipoAsociacion
      //   ) || [];
      const beneficiadosTemporales = beneficiados;

      beneficiadoTemp = beneficiado.cargo
        ? beneficiadosTemporales?.find((b) => b.cargo === beneficiado.cargo)
        : beneficiadosTemporales[0] || {};

      if (beneficiadoTemp === undefined) {
        const beneficiadoFormateado = {
          ...beneficiadosTemporales[0],
          cargo: beneficiado.cargo,
          pkBeneficiado: index + 1
        };
        return beneficiadoFormateado;
      }
      const beneficiadoFormateado = {
        ...beneficiadoTemp,
        pkBeneficiado: index + 1
      };
      return beneficiadoFormateado;
    }

    if (beneficiado.beneficiado === undefined && beneficiado.idSujetoObligado === 0) {
      const beneficiadosTemporales =
        catalogoBeneficiados?.filter(
          (b) =>
            b.idProcesoSIMAC === idProcesoEspecifico &&
            b.idTipoAsociacion === beneficiado.idTipoAsociacion
        ) || [];

      beneficiadoTemp = beneficiado.cargo
        ? beneficiadosTemporales?.find((b) => b.cargo === beneficiado.cargo)
        : beneficiadosTemporales[0] || {};

      if (beneficiadoTemp === undefined) {
        const beneficiadoFormateado = {
          ...beneficiadosTemporales[0],
          cargo: beneficiado.cargo,
          idSujetoObligado: beneficiado.idSujetoObligado,
          sujetoObligado: beneficiado.sujetoObligado,
          pkBeneficiado: index + 1
        };
        return beneficiadoFormateado;
      }
      const beneficiadoFormateado = {
        ...beneficiadoTemp,
        idSujetoObligado: beneficiado.idSujetoObligado,
        sujetoObligado: beneficiado.sujetoObligado,
        pkBeneficiado: index + 1
      };
      return beneficiadoFormateado;
    }

    const beneficiadoFormateado = {
      ...beneficiado,
      pkBeneficiado: index + 1 // Dato arbitrario solicitado por el backend
    };
    return beneficiadoFormateado;
  });

  let beneficiadosFormateadosSinDuplicidad;

  if (beneficiados?.length !== 0 && beneficiados[0].beneficiado === undefined) {
    beneficiadosFormateadosSinDuplicidad = eliminarObjetosDuplicadosPorPropiedad(
      beneficiadosFormateados,
      'nombreBeneficiado',
      'idTipoAsociacion',
      'idContabilidad'
    );
  }

  beneficiadosFormateadosSinDuplicidad = eliminarObjetosDuplicadosPorPropiedad(
    beneficiadosFormateados,
    'nombreBeneficiado',
    'idTipoAsociacion',
    'idSujetoObligado',
    'cargo'
  );

  beneficiadosOriginales?.map((beneficiadoOriginal) => {
    let updatedBeneficiado = {};

    const index = findElementNomBene(
      beneficiadosFormateadosSinDuplicidad,
      beneficiadoOriginal.nombreBeneficiado
    );

    if (index !== -1 && index !== null) {
      updatedBeneficiado = {
        ...beneficiadosFormateadosSinDuplicidad[index],
        idBeneficiado: beneficiadoOriginal.idBeneficiado
      };
      beneficiadosFormateadosSinDuplicidad[index] = updatedBeneficiado;
      return updatedBeneficiado;
    }

    updatedBeneficiado = {
      ...beneficiadoOriginal,
      estatus: 0
    };

    beneficiadosFormateadosSinDuplicidad.push(updatedBeneficiado);
    return updatedBeneficiado;
  });
  return beneficiadosFormateadosSinDuplicidad;
};
